<ng-container *ngIf="cardTurnoActual as notifCard">
  <div class="turno-nuevo-card-anchor">
    <div class="turno-nuevo-card" *ngIf="cardTurnoVisible" @turnoNuevoCard>
      <div class="turno-nuevo-card__contenido">
        <p class="turno-nuevo-card__titulo">Ha llegado un nuevo turno para ser atendido</p>
        <p class="turno-nuevo-card__linea">
          <strong>Nombre:</strong> {{ notifCard.payload.nombre_socio || '—' }}
        </p>
        <p class="turno-nuevo-card__linea">
          <strong>Trámite:</strong> {{ tramitesCardTurno(notifCard.payload) }}
        </p>
        <p class="turno-nuevo-card__linea">
          <strong>Hora:</strong> {{ horaCardTurno(notifCard.payload) }}
        </p>
      </div>
      <button
        type="button"
        class="turno-nuevo-card__btn"
        (click)="aceptarCardTurno()">
        <span class="turno-nuevo-card__btn-fondo"></span>
        <span
          class="turno-nuevo-card__btn-llenado"
          [style.width.%]="progresoBotonCard"></span>
        <span class="turno-nuevo-card__btn-texto">Cerrar ...{{ segundosCardTurno }}s</span>
      </button>
    </div>
  </div>
</ng-container>

<mat-toolbar class="topbar horizontal-topbar" [class.horizontal-topbar--con-turno]="turnoEnAtencion">
  <div
    class="container header-container"
    [class.header-container--con-turno]="turnoEnAtencion">
    <div class="header-start">
      <div class="d-none d-sm-flex">
        <div class="branding">
          <a routerLink="/" class="d-inline-block">
            <img src="./assets/images/logos/logo-sdm-hrz.png" class="align-middle m-2" alt="logo" />
          </a>
        </div>
      </div>

      <button
        *ngIf="!menuHorizontalVisible"
        mat-icon-button
        type="button"
        (click)="toggleMobileNav.emit()"
        aria-label="Abrir menú">
        <i-tabler name="align-left" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>

    <ng-container *ngIf="turnoEnAtencion as turno; else headerEspaciador">
      <div class="header-center">
        <div class="panel-en-atencion">
          <div class="panel-en-atencion-body">
            <div class="panel-en-atencion-detalle">
              <div class="panel-en-atencion-linea panel-en-atencion-linea--superior">
                <span class="panel-en-atencion-titulo">En atención</span>
                <div class="panel-campo panel-campo--nombre">
                  <span class="panel-campo-label">{{ etiquetaMaestro(turno) }}:</span>
                  <span class="panel-campo-valor">{{ turno.nombre_socio }}</span>
                </div>
              </div>
              <div class="panel-en-atencion-linea panel-en-atencion-linea--inferior">
                <div class="panel-campo panel-campo--rfc">
                  <span class="panel-campo-label">RFC:</span>
                  <span class="panel-campo-valor">{{ turno.rfc || '—' }}</span>
                </div>
                <div class="panel-campo panel-campo--tramite">
                  <span class="panel-campo-label">{{ etiquetaTramite(turno) }}:</span>
                  <span class="panel-campo-valor">{{ tramitesTexto(turno) }}</span>
                </div>
                <button
                  mat-icon-button
                  type="button"
                  class="panel-en-atencion-ver"
                  [matTooltip]="detalleTurnoTooltip(turno)"
                  matTooltipClass="panel-en-atencion-tooltip"
                  matTooltipPosition="below"
                  aria-label="Ver detalle del turno en atención">
                  <i-tabler name="eye" class="icon-18 d-flex"></i-tabler>
                </button>
              </div>
            </div>
            <div class="panel-en-atencion-acciones">
              <button
                mat-raised-button
                color="primary"
                type="button"
                class="panel-en-atencion-btn panel-en-atencion-btn--kardex"
                *ngIf="turno.maestro_id"
                (click)="irAlKardex(turno)">
                Ver kárdex
              </button>
              <button
                mat-raised-button
                color="accent"
                type="button"
                class="panel-en-atencion-btn panel-en-atencion-btn--asignar"
                *ngIf="!turno.maestro_id"
                (click)="irAsignarInscribir(turno)">
                Asignar/Inscribir
              </button>
              <button
                mat-stroked-button
                type="button"
                class="panel-en-atencion-btn panel-en-atencion-btn--pausar"
                (click)="pausarAtencion(turno)">
                Pausar
              </button>
              <button
                mat-flat-button
                type="button"
                class="panel-en-atencion-btn panel-en-atencion-btn--concluir"
                [disabled]="!puedeConcluirAtencion(turno)"
                (click)="abrirConcluirAtencion(turno)">
                Concluir atención
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #headerEspaciador>
      <span class="flex-1-auto"></span>
    </ng-template>

    <div class="header-end">
      <div class="socio-op-chip" *ngIf="socioOpEstado.chip$ | async as chip">
        <mat-spinner diameter="16"></mat-spinner>
        <span>{{ socioOpEstado.mensajeChip(chip) }}</span>
      </div>
      <div class="btn-notif-wrap m-r-8">
        <button
          mat-icon-button
          [matMenuTriggerFor]="notificationMenu"
          aria-label="Notificaciones"
          type="button">
          <i-tabler class="d-flex" name="bell"></i-tabler>
          <ng-container *ngIf="nuevasCount$ | async as cnt">
            <span class="badge-notif" *ngIf="cnt > 0">{{ cnt }}</span>
          </ng-container>
        </button>
        <mat-menu #notificationMenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
          <div class="d-flex align-items-center p-x-32 p-y-16">
            <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Notificaciones</h6>
            <ng-container *ngIf="nuevasCount$ | async as cntNuevas">
              <span class="m-l-16" *ngIf="cntNuevas > 0">
                <span class="bg-warning text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">{{ cntNuevas }} nueva(s)</span>
              </span>
            </ng-container>
          </div>

          <div class="seccion-notif-titulo">Atención de Turnos</div>

          <ng-container *ngIf="(notificacionesAtencion$ | async) as lista">
            <button
              mat-menu-item
              class="p-x-32 p-y-12"
              *ngFor="let n of lista"
              (click)="onClickNotificacion(n, $event)">
              <div class="notif-item" [ngClass]="claseNotificacion(n)">
                <div>
                  <div class="f-s-14 f-w-600">{{ tituloNotificacion(n) }}</div>
                  <div class="f-s-12">{{ subtituloNotificacion(n) }}</div>
                </div>
                <button
                  mat-icon-button
                  class="notif-borrar"
                  type="button"
                  aria-label="Borrar"
                  (click)="onBorrarNotificacion(n, $event)">
                  <i-tabler name="trash" class="icon-18"></i-tabler>
                </button>
              </div>
            </button>
            <div class="p-x-32 p-y-16 f-s-13" *ngIf="lista.length === 0">
              Sin notificaciones de turnos.
            </div>
          </ng-container>

          <div class="p-y-12 p-x-32">
            <button mat-stroked-button color="primary" class="w-100" routerLink="/citas-zona-atencion">
              Ir a zona de atención
            </button>
          </div>
        </mat-menu>
      </div>

      <button
        mat-fab
        extended
        color="inherit"
        [matMenuTriggerFor]="profileMenu"
        aria-label="Perfil de usuario"
        class="disabled-hover">
        <div class="d-flex align-items-center">
          <img
            src="/assets/images/profile/user_generico.png"
            class="rounded-circle object-cover"
            width="40"
          />

          <div class="m-l-16 text-left d-none d-lg-flex">
            <div>
              <h5 class="f-s-16">{{ userName }}</h5>
              <span class="f-s-14 mat-body-1">{{ userRole }}</span>
            </div>
          </div>
        </div>
      </button>
      <mat-menu
        #profileMenu="matMenu"
        xPosition="before"
        class="topbar-dd cardWithShadow">
        <ng-scrollbar class="position-relative" style="height: 260px">
          <div class="p-x-32 p-y-16">
            <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">Perfil del usuario</h6>

            <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
              <img
                src="/assets/images/profile/user_generico.png"
                class="rounded-circle"
                width="95"
              />
              <div class="m-l-16">
                <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ userName }}</h6>
                <span class="f-s-14 mat-body-1 d-block m-b-4">{{ userRole }}</span>
                <span class="d-flex align-items-start" style="word-break: break-all;">
                  <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
                  {{ userCorreo }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-y-12 p-x-32">
            <button
              mat-flat-button
              color="primary"
              class="w-100"
              (click)="logout()">
              Salir
            </button>
          </div>
        </ng-scrollbar>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>
